import Transformer from "../transformer";
import ObjectToForm from "../../utils/objectToForm";
import moment from "moment";

export default class imagesTransformer extends Transformer {
  static send(acenad, invoice) {
    let payload = {
      invoice_receipt: invoice.id,
      stamped_date: moment(invoice.stampedDate).format("YYYY-MM-DD"),
      affected: acenad.affected,
      file_type: acenad.fileType,
      is_active: true,
      amount: acenad.amount,
      date_content: acenad.date_content,
      visible_customer: !!acenad.visibleCustomer,
    };
    if (acenad.file) {
      payload.file = acenad.file;
      payload.file_type = acenad.fileType;
    }
    if (invoice.stampedFile) {
      payload.stamped_file = invoice.stampedFile;
    }

    const fd = ObjectToForm(payload);
    return fd;
  }
}



// WEBPACK FOOTER //
// ./src/transformers/Files/acenadStampedInvoice.js